import React, { FC, useEffect } from 'react';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';

import {
    Checkbox,
    Button,
    DialogActions,
    DialogContent,
    TextField,
    FormControl,
    Chip,
    Box,
    ListItemText,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import CancelIcon from '@mui/icons-material/Cancel';

import { MenuCommand } from '../../../services/command';
import { MenuQuery } from '../../../services/query';
import './SCUIMenuRoleDialogContent.scss';

interface IProps {
    selectedRow?: any;
    onCloseDialog?: any;
    roles?: any;
}

export const SCUIMenuRoleDialogContent: FC<IProps> = ({ selectedRow = null, onCloseDialog, roles }) => {
    const [roleName, setRoleName] = React.useState<any[]>([]);
    const { t } = useTranslation();

    useEffect(() => {
        GetRolesList();
    }, []);

    const GetRolesList = () => {
        MenuQuery.GetMenuRoleList(selectedRow.menuItemId)
            .then((res: any) => {
                if (res) {
                    const roleIds = res.model.data.map((item: any) => item.roleId);
                    setRoleName(roleIds);
                }
            })
            .catch((error: any) => {
                console.log('Error:', error);
            });
    };

    const handleDelete = (e: React.MouseEvent, value: string) => {
        e.preventDefault();
        setRoleName((current) => current.filter((item) => item !== value));
    };

    const handleAutocompleteChange = (_: any, value: any[]) => {
        setRoleName(value.map((item: any) => item.roleId));
    };

    const submitHandler = (event: any) => {
        event.preventDefault();
        const params = {
            menuId: selectedRow.menuItemId,
            roleID: roleName,
        };
        MenuCommand.PostMenuItemRoleAdd(params).then(() => {
            Swal.fire(t('general.updated'), ' ', 'success');
            onCloseDialog();
        });
    };

    return (
        <div>
            <form onSubmit={submitHandler}>
                <DialogContent
                    sx={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        minWidth: '400px',
                    }}
                >
                    <FormControl sx={{ m: 1, width: '80%' }}>
                        <Autocomplete
                            multiple
                            options={roles || []}
                            getOptionLabel={(option: any) => option.roleNameKey}
                            value={roles?.filter((role: any) => roleName?.includes(role.roleId)) || []}
                            onChange={handleAutocompleteChange}
                            renderInput={(params) => (
                                <TextField {...params} label={t('menuManagement.roleList')} variant="outlined" />
                            )}
                            renderValue={() => null}
                            renderOption={(props, option) => (
                                <li {...props}>
                                    <Checkbox checked={roleName?.includes(option.roleId)} />
                                    <ListItemText primary={option.roleNameKey} />
                                </li>
                            )}
                        />
                    </FormControl>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 2 }}>
                        {roleName.map((roleId: any) => (
                            <Chip
                                key={roleId}
                                label={roles?.find((e: any) => e.roleId === roleId)?.roleNameKey}
                                clickable
                                deleteIcon={<CancelIcon onMouseDown={(event: any) => event.stopPropagation()} />}
                                onDelete={(e) => handleDelete(e, roleId)}
                            />
                        ))}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button type="submit">{t('general.update')}</Button>
                    <Button onClick={onCloseDialog}>{t('general.cancel')}</Button>
                </DialogActions>
            </form>
        </div>
    );
};
